// removed by extract-text-webpack-plugin
module.exports = {"bookmarksList":"nY-tt","loadMoreButton":"_1zht7","inventoryRecordsList":"_1iD9n"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/BookmarksList/index.sass
// module id = 1463
// module chunks = 1